import { render, staticRenderFns } from "./TussenStand.vue?vue&type=template&id=298a1d86&scoped=true&"
import script from "./TussenStand.vue?vue&type=script&lang=ts&"
export * from "./TussenStand.vue?vue&type=script&lang=ts&"
import style0 from "./TussenStand.vue?vue&type=style&index=0&id=298a1d86&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298a1d86",
  null
  
)

export default component.exports